import React from 'react';
import { Link } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';

export default function TermsAndConditions() {
  return (
    <div style={{
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
      color: "#333",
      minHeight: "100vh",
      fontFamily: "'Poppins', Arial, sans-serif",
      padding: "40px 20px"
    }}>
      <div style={{
        maxWidth: "800px",
        margin: "0 auto",
        background: "#ffffff",
        padding: "40px",
        borderRadius: "16px",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
        border: "1px solid rgba(76, 175, 80, 0.1)"
      }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <Link to="/" style={{
            display: "inline-flex",
            alignItems: "center",
            color: "#4caf50",
            textDecoration: "none",
            fontSize: "1.1rem",
            marginBottom: "20px",
            background: "#f0f9f0",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#4caf50";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f0f9f0";
            e.target.style.color = "#4caf50";
          }}>
            <i className="fa fa-arrow-left" style={{ marginRight: "10px" }} />
            Back to Home
          </Link>
          <img 
            src="/images/logo.png" 
            alt="V-EDITOR Logo" 
            width="80"
            style={{ marginBottom: "20px" }}
          />
          <h1 style={{ 
            fontSize: "2.5rem", 
            marginBottom: "10px",
            color: "#2d3748",
            fontWeight: "600"
          }}>
            Terms & Conditions
          </h1>
          <p style={{ color: "#718096", fontSize: "0.9rem" }}>
            Last Updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* Content */}
        <div style={{
          fontSize: "0.95rem",
          lineHeight: "1.7",
          color: "#4a5568"
        }}>
          {/* GUEST USER SECTION */}
          <section style={{ 
            marginBottom: "30px",
            background: "#f0f9f0",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #c3e6cb"
          }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-user-circle" style={{ color: "#4caf50" }} />
              Guest User Terms
            </h2>
            <p style={{ marginBottom: "10px" }}>
              As a <strong>guest user</strong> of V-EDITOR, you agree to the following:
            </p>
            <ul style={{ paddingLeft: "20px", margin: "15px 0" }}>
              <li>You can access basic features without creating an account</li>
              <li>Your session data is temporary and automatically deleted after 30 days of inactivity</li>
              <li>No personal information is required to use core features</li>
              <li>You remain anonymous while using the platform as a guest</li>
              <li>Guest access may have limited features compared to registered users</li>
              <li>You can provide feedback without revealing your identity</li>
              <li>We collect anonymous usage data to improve the service for all users</li>
            </ul>
            <p style={{
              background: "#ffffff",
              padding: "12px",
              borderRadius: "8px",
              marginTop: "10px",
              borderLeft: "4px solid #4caf50"
            }}>
              <i className="fa fa-info-circle" style={{ color: "#4caf50", marginRight: "8px" }} />
              <strong>Guest-friendly:</strong> You never need to register to try V-EDITOR. Your privacy matters to us.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-check-circle" style={{ color: "#4caf50" }} />
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using V-EDITOR as a <strong>guest</strong> or <strong>registered user</strong>, 
              you agree to these Terms & Conditions. If you don't agree, please don't use our service.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-clock-o" style={{ color: "#4caf50" }} />
              2. Guest Access & Waitlist
            </h2>
            <p>When you use V-EDITOR as a guest or join our waitlist, you understand that:</p>
            <ul style={{ paddingLeft: "20px", margin: "15px 0" }}>
              <li><strong>Guest users:</strong> Can try features without registration</li>
              <li><strong>Waitlist sign-ups:</strong> This is not a purchase or guarantee of access</li>
              <li>You'll receive email updates about our launch (if email provided)</li>
              <li>You can unsubscribe from communications at any time</li>
              <li>Launch dates and feature availability may change</li>
              <li>Guest sessions are temporary and may expire after inactivity</li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-exclamation-triangle" style={{ color: "#4caf50" }} />
              3. No Guarantees
            </h2>
            <p>
              V-EDITOR is currently in development. Features shown on our website 
              (Live Coding, Chat, Voice, AI Assistance) are planned but not guaranteed. 
              The service is provided "as is" without any warranties. Guest access may be 
              limited or modified at any time.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-ban" style={{ color: "#4caf50" }} />
              4. Acceptable Use
            </h2>
            <p>All users (guests and registered) agree <strong>NOT</strong> to:</p>
            <ul style={{ paddingLeft: "20px", margin: "15px 0" }}>
              <li>Submit false or fraudulent information</li>
              <li>Use bots or automated systems to access the platform</li>
              <li>Attempt to hack, disrupt, or overload our systems</li>
              <li>Share others' personal information without permission</li>
              <li>Use the service for illegal activities</li>
              <li>Impersonate other users or create fake guest sessions</li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-copyright" style={{ color: "#4caf50" }} />
              5. Intellectual Property
            </h2>
            <p>
              All content on V-EDITOR, including but not limited to:
            </p>
            <ul style={{ paddingLeft: "20px", margin: "15px 0" }}>
              <li>Logo and branding</li>
              <li>Website design and layout</li>
              <li>"Code. Chat. Collaborate." tagline</li>
              <li>Feature descriptions and UI elements</li>
              <li>Documentation and tutorials</li>
            </ul>
            <p>
              is our property or used under license. Don't copy, modify, or misuse our intellectual property.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-gavel" style={{ color: "#4caf50" }} />
              6. Limitation of Liability
            </h2>
            <p>
              We're not liable for:
            </p>
            <ul style={{ paddingLeft: "20px", margin: "15px 0" }}>
              <li>Any email delivery issues or communication delays</li>
              <li>Changes to our launch timeline or feature set</li>
              <li>Lost opportunities, data, or sessions</li>
              <li>Third-party actions or integrations</li>
              <li>Temporary unavailability of guest access</li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-refresh" style={{ color: "#4caf50" }} />
              7. Changes to Terms
            </h2>
            <p>
              We may update these Terms & Conditions. We'll post updates on this page. 
              Continued use of V-EDITOR (as guest or registered user) means you accept the changes.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2 style={{ 
              color: "#2d3748", 
              fontSize: "1.3rem", 
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <i className="fa fa-envelope" style={{ color: "#4caf50" }} />
              8. Contact Information
            </h2>
            <p>
              For questions about these Terms, contact us at:
              <br />
              <a href="mailto:veditort@gmail.com" style={{ 
                color: "#4caf50",
                textDecoration: "none",
                fontWeight: "500"
              }}>
                veditort@gmail.com
              </a>
              <br />
              <span style={{ color: "#718096", fontSize: "0.9rem" }}>
                Response within 48 hours
              </span>
            </p>
          </section>

          <div style={{
            marginTop: "40px",
            padding: "20px",
            background: "#f8f9fa",
            borderRadius: "10px",
            fontSize: "0.85rem",
            color: "#666",
            border: "1px solid #e2e8f0"
          }}>
            <p style={{ marginBottom: "10px" }}>
              <strong>Guest User Notice:</strong> These terms apply to all users, including those accessing 
              V-EDITOR without registration. Your continued use as a guest constitutes acceptance of these terms.
            </p>
            <p>
              <strong>Disclaimer:</strong> Full terms for the complete V-EDITOR application will be provided upon product launch.
            </p>
          </div>
        </div>

        {/* Footer Links - UPDATED with correct Contact link */}
        <div style={{
          marginTop: "40px",
          display: "flex",
          justifyContent: "center",
          gap: "30px",
          flexWrap: "wrap",
          padding: "20px 0",
          borderTop: "1px solid #e2e8f0"
        }}>
          <Link to="/privacy" style={{
            color: "#4a5568",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease",
            background: "#f8f9fa"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#4caf50";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f8f9fa";
            e.target.style.color = "#4a5568";
          }}>
            <i className="fa fa-shield-alt" /> Privacy Policy
          </Link>
          
          <Link to="/" style={{
            color: "#4a5568",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease",
            background: "#f8f9fa"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#4caf50";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f8f9fa";
            e.target.style.color = "#4a5568";
          }}>
            <i className="fa fa-home" /> Home
          </Link>
          
          {/* UPDATED: Changed from <a> to <Link> with correct path */}
          <Link to="/contact" style={{
            color: "#4a5568",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease",
            background: "#f8f9fa"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#4caf50";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f8f9fa";
            e.target.style.color = "#4a5568";
          }}>
            <i className="fa fa-envelope" /> Contact
          </Link>
        </div>
      </div>

      {/* Global Footer */}
      <footer style={{
        marginTop: "40px",
        textAlign: "center",
        color: "#718096",
        fontSize: "0.8rem",
        padding: "20px"
      }}>
        <p>© {new Date().getFullYear()} V-EDITOR. All rights reserved.</p>
        <p style={{ 
          marginTop: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px"
        }}>
          <i className="fa fa-user-circle" style={{ color: "#4caf50" }} />
          Guest friendly • No account required for basic features
        </p>
        <p style={{ marginTop: "10px", color: "#4caf50", fontWeight: "500" }}>
          Code. Chat. Collaborate.
        </p>
      </footer>
    </div>
  );
}